module.exports = __webpack_public_path__ + "media/fans_cheering_2.213cf260.mp3";